import { getConfigurations } from '@/model/draft/getConfigurations';
import { getDraft } from '@/redux/draft/getters/getDraft';
import { StoreState } from '@/redux/types';

export function selectConfigurations(state: StoreState) {
  return getConfigurations(getDraft(state));
}

export function selectActiveDraftConfiguration(state: StoreState) {
  const draft = state.draft;

  return selectConfigurations(state).find((config) => {
    return config.cid === draft.selectedConfigurationId;
  });
}
